module.exports = __webpack_public_path__ + "static/img/suc-img.684bf8e3.png";